/**
 * Format and color-code runtime duration
 * Red: >= 5 mins
 * Orange: >= 2.5 mins
 * Green: <= 2 mins
 */

export const formatRuntime = (batch) => {
  // Use totalRuntimeMin from API if available (calculated from PIPELINE_SUMMARY events)
  if (batch.totalRuntimeMin && batch.totalRuntimeMin > 0) {
    const totalMinutes = batch.totalRuntimeMin;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.floor(totalMinutes % 60);
    const seconds = Math.round((totalMinutes % 1) * 60);

    let display = '';
    if (hours > 0) {
      display = `${hours}h ${minutes}m`;
    } else if (minutes > 0) {
      display = `${minutes}m ${seconds}s`;
    } else {
      display = `${seconds}s`;
    }

    return { display, totalMinutes };
  }

  if (!batch.completedAt || batch.status !== 'COMPLETED') return '-';
  try {
    const created = new Date(batch.createdAt).getTime();
    const completed = new Date(batch.completedAt).getTime();
    const diffMs = completed - created;

    if (diffMs < 0) return '-';

    const seconds = Math.floor((diffMs / 1000) % 60);
    const minutes = Math.floor((diffMs / (1000 * 60)) % 60);
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const totalMinutes = diffMs / (1000 * 60);

    let display = '';
    if (hours > 0) {
      display = `${hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
      display = `${minutes}m ${seconds}s`;
    } else {
      display = `${seconds}s`;
    }

    return { display, totalMinutes };
  } catch (err) {
    return '-';
  }
};

export const getRuntimeColor = (runtimeResult) => {
  if (!runtimeResult || typeof runtimeResult === 'string') {
    return { color: '#a0aec0', bg: 'transparent' }; // Gray for "-"
  }

  const { totalMinutes } = runtimeResult;

  if (totalMinutes >= 5) {
    return { color: '#991B1B', bg: '#FEE2E2' }; // Red for >= 5 mins
  } else if (totalMinutes >= 2.5) {
    return { color: '#B45309', bg: '#FEF3C7' }; // Orange for >= 2.5 mins
  } else {
    return { color: '#166534', bg: '#DCFCE7' }; // Green for <= 2 mins
  }
};

export const formatRuntimeDisplay = (batch) => {
  const result = formatRuntime(batch);

  if (typeof result === 'string') {
    return { display: result, color: '#a0aec0', bg: 'transparent' };
  }

  const { display, totalMinutes } = result;
  const colorScheme = getRuntimeColor(result);

  return {
    display,
    color: colorScheme.color,
    bg: colorScheme.bg
  };
};
